/**
 * Whether a lab result may be shown to the member it belongs to.
 *
 * Mirrors `functions/inuvi/reviewGate.js#isVisibleToMember`. Machine-ingested
 * results from Inuvi are held for clinician review unless the lab explicitly
 * flagged them normal; a clinician releasing one flips `reviewState` and it
 * becomes visible here.
 *
 * Deliberately "not held" rather than "released": results predating the gate
 * carry `machine_ingested` or no state at all, and treating those as held would
 * retroactively hide labs members can see today. Only `awaiting_review` hides.
 *
 * This is a member-facing filter only. Clinician and ops views intentionally see
 * everything — that is the whole point of a review queue — and the decision
 * engine reads the raw collection, since its output is itself reviewed before
 * release.
 */
export const AWAITING_REVIEW = 'awaiting_review';

export function isVisibleToMember(labResult: { reviewState?: string | null } | null | undefined): boolean {
  return labResult?.reviewState !== AWAITING_REVIEW;
}

export function filterVisibleToMember<T extends { reviewState?: string | null }>(results: T[]): T[] {
  return results.filter(isVisibleToMember);
}
